// Shared connectivity probe helper for Chit Chats Print.
//
// The setup page uses the secure local HTTPS listener for diagnostics. The
// print flow uses the same origin for WSS (/print), so a successful HTTPS
// probe is enough to confirm the browser can reach the local app without
// keeping a second WebSocket-only probe endpoint alive.
import { DEFAULT_BASE_URL, getBaseUrl } from "./chit_chats_print_agent_base_url";

const HTTP_PROBE_TIMEOUT_MS = 5000;

function httpProbe(baseUrl) {
  return new Promise(function(resolve) {
    var controller = new AbortController();
    var timer = window.setTimeout(function() {
      controller.abort();
    }, HTTP_PROBE_TIMEOUT_MS);

    fetch(baseUrl + "/v1/diagnostics", { method: "GET", signal: controller.signal })
      .then(function(resp) {
        window.clearTimeout(timer);
        if (!resp.ok) {
          resolve({ ok: false, error: "http_status_" + resp.status });
          return null;
        }
        return resp.json().then(function(body) {
          resolve({ ok: true, body: body });
        });
      })
      .catch(function(err) {
        window.clearTimeout(timer);
        // Browsers deliberately collapse local-network failure modes
        // into vague TypeErrors. Keep the status UI simple and let the
        // setup page's help section guide user recovery.
        var name = err && err.name;
        resolve({ ok: false, error: name === "AbortError" ? "http_timeout" : "http_failed" });
      });
  });
}

// RunConnectivityProbe returns the setup state machine result shape.
function runConnectivityProbe(baseUrl) {
  var resolvedBase = baseUrl || getBaseUrl();
  return httpProbe(resolvedBase).then(function(http) {
    return {
      baseUrl: resolvedBase,
      http: http,
      success: http.ok
    };
  });
}

export {
  DEFAULT_BASE_URL,
  runConnectivityProbe,
  getBaseUrl
};
